import { Subscription, SubscriptionStatus } from "../types";

export default class SubscriptionHelper {
	static active(subscription: Subscription) {
		return [SubscriptionStatus.TRIALING, SubscriptionStatus.ACTIVE].includes(subscription.status)
	}
}